module.exports = __webpack_public_path__ + "static/media/delete-remove-trash-svgrepo-com.907a2837.svg";